import { Calculator as V2 } from './calculator/v2';
import { Calculator as V3 } from './calculator/v3';

export default { 2: V2, 3: V3 };
